import { render, staticRenderFns } from "./TourNav.vue?vue&type=template&id=614b23d0&scoped=true&"
import script from "./TourNav.vue?vue&type=script&lang=js&"
export * from "./TourNav.vue?vue&type=script&lang=js&"
import style0 from "./TourNav.vue?vue&type=style&index=0&id=614b23d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614b23d0",
  null
  
)

component.options.__file = "TourNav.vue"
export default component.exports